(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/models/super/entry.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/models/super/entry.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  const trinidad = svs.core;
  svs.tur.start_subscription.models.Entry = Backbone.Model.extend({
    CONSTANTS: svs.tur.start_subscription.constants,
    defaults() {
      return {
        subscriptionId: undefined,
        entry: undefined,
        isAutogiro: false,
        isBankcard: false,
        hasActivePayChannel: false,
        amount: undefined,
        paymentTypeText: undefined,
        payTime: undefined,
        startTime: undefined,
        stopTime: undefined,
        newSubId: undefined,
        firstAndLastName: undefined,
        personalId: undefined,
        bankAccountNumber: undefined,
        clearingNumber: undefined,
        accountNumber: undefined,
        bankName: undefined,
        cancelUrl: undefined,
        isNewSubOnlyBankcard: false
      };
    },
    parseAutogiroInfo(data) {
      const autogiroData = {};
      let bankAccounts;
      for (let i = 0; i < data.responses.length; i++) {
        const response = data.responses[i].response;
        if (response.personalId) {
          autogiroData.personalId = response.personalId;
          autogiroData.firstAndLastName = "".concat(response.firstName, " ").concat(response.lastName);
        }
        if (response.bankAccounts) {
          bankAccounts = response.bankAccounts[0];
          autogiroData.accountNumber = bankAccounts.accountNumber;
          autogiroData.clearingNumber = bankAccounts.clearingNumber;
          autogiroData.bankAccountNumber = autogiroData.clearingNumber + autogiroData.accountNumber;
          autogiroData.bankName = bankAccounts.bankName;
        }
        if (response.playerProperties) {
          autogiroData.customerId = response.playerProperties.customerId;
        }
      }
      return autogiroData;
    },
    getAutogiroInfo(options) {
      options = options || {};

      const model = this;
      const context = options.context;
      const successCallback = options.success;

      options.success = async function () {
        try {
          const useOldJupiterApi = !svs.core.detect.feature('ft-elza-bankaccount');
          const jupiterUrls = ["/player/3/info", '/player/1/properties?propertyList=customerId'];
          const jupiterPromises = jupiterUrls.map(url => trinidad.jupiter.callAsync({
            method: 'GET',
            path: url,
            req: options.req
          }));
          let bankAccountPromise;
          if (useOldJupiterApi) {
            bankAccountPromise = trinidad.jupiter.callAsync({
              method: 'GET',
              path: '/player/1/bankaccounts',
              req: options.req
            });
          } else {
            const svsFetch = svs.core.svsFetch.create();
            bankAccountPromise = (async () => {
              const fetchResponse = await svsFetch('/bank-accounts/v1/customers/me', {
                method: 'GET'
              });
              if (!fetchResponse.ok) {
                if ([401, 403].includes(fetchResponse.status)) {
                  window.location.href = '/logga-ut';
                  return {
                    response: {
                      bankAccounts: []
                    }
                  };
                }
                const body = await fetchResponse.json().catch(() => null);
                const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'Error fetching bank accounts';
                throw new Error(errorDetail);
              }
              const responseData = await fetchResponse.json();
              const bankAccountData = (responseData === null || responseData === void 0 ? void 0 : responseData.data) || {};
              return {
                response: {
                  bankAccounts: [{
                    clearingNumber: bankAccountData.clearingNumber || '',
                    accountNumber: bankAccountData.accountNumber || '',
                    bankName: bankAccountData.bankName || ''
                  }]
                }
              };
            })();
          }
          const responses = await Promise.all([jupiterPromises[0], bankAccountPromise, jupiterPromises[1]]);

          const data = {
            responses
          };

          const attr = model.parseAutogiroInfo(data);
          model.set(attr);
          svs.components.loader.hide();
          if (successCallback) {
            successCallback.call(context, model, data, options);
          }
        } catch (error) {
          model.parseError(error);
        }
      };
      options.error = model.parseError;

      options.attrs = {};

      options.url = "".concat(svs.core.jupiter.url(), "/player/3/info");
      svs.components.loader.show();
      this.sync('read', this, options);
    },
    parseError(xhr) {
      svs.tur.start_subscription.radio.trigger('handleError', xhr);
    },
    reset() {
      this.clear({
        silent: true
      });
    }
  });
})(Backbone, _, svs);

 })(window);